/**
 * Created by fky on 3/23/2017.
 */
(function () {
  'use strict';

  angular
    .module('betosyswebapp')
    .directive('noDataAvailable', function () {
      return {
        restrict: 'E',
        templateUrl: 'components/common/directives/noDataAvailable.tpl.html',
        replace: true,
        link: function (scope) {
          scope.$parent.isWidgetPreInitFinished = true; // disable the PreInit animation;
        }
      };
    });
})();



// WEBPACK FOOTER //
// ./.tmp/components/common/directives/noDataAvailableDirective.js